import React, { useEffect, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Alert, Col, Row } from "reactstrap";
import myImage from "../assets/avantSolar/logo_avantsolar.gif";
import { useDispatch, useSelector } from "react-redux";
import { redirigirSegunUser } from "utils/generalFunctions";
import { loginAuth } from "store/slices/auth/thunks";
import SpinnerAvantsolar from "components/utils/spinner";
import { errorMessageAction } from "store/slices/auth/authSlices";
import { errorMessageNullAction } from "store/slices/auth/authSlices";
import { Helmet } from "react-helmet-async";

function Login() {
  const [datosLogin, setDatosLogin] = useState({ username: "", password: "" });
  const reCaptcha = useRef();
  const [captchaValido, setcaptchaValido] = useState(null);
  const [mostrarPassword, setMostrarPassword] = useState(false);
  const { user, errorMessage, status } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(errorMessageNullAction());
  }, []);

  async function logIn(event) {
    event.preventDefault();
    

    if (captchaValido) {
  
      datosLogin.recaptchaResponse = reCaptcha.current.getValue();
      dispatch(loginAuth(datosLogin));
    } else {
      setcaptchaValido(false);
      dispatch(errorMessageNullAction());
    }
    reCaptcha.current.reset();
  }

  //Setear datos del formulario
  function handleChangeForm(event) {
    const { target } = event;
    const { name, value } = target;
    setDatosLogin({ ...datosLogin, [name]: value });
  }

  const onChangeReCaptcha = () => {
    setcaptchaValido(null);
    //Catpcha resuelto
    if (reCaptcha.current.getValue()) {
      console.log(reCaptcha.current.getValue());
      setcaptchaValido(true);
    } else {
      setcaptchaValido(false);
    }
  };

  const handleChangeShowPassword = () => {
    console.log("Clic");
    setMostrarPassword(!mostrarPassword)
  }

  if (!user) {
    return (
      <>
        <Helmet>
          <title>AvantSolar</title>
          <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
          <meta
            name="author"
            content="Desarrollado por el departamento de diseño AvantSolar"
          />
          <meta name="copyright" content="Copyright 2018 AvantSolar" />
          <meta http-equiv="Content-Language" content="es" />
          <meta name="generator" content="Descripción AvantSolar" />
          <meta name="distribution" content="AvantSolar" />
          <meta name="robots" content="all" />
          <meta charset="utf-8" />
          <meta
            name="description"
            content="AvantSolar. ACCESO CLIENTES. Usuario: Contraseña: Huerta: Tabernas, Iniesta, Villanueva Mesia, V. de la Jara, Albox, SSEE. Copyright © 2005-2010 Avantsolar"
          />
          <meta
            name="viewport"
            content="width=device-width; initial-scale=1.0; maximum-scale=1.0; user-scalable=0;"
          />
          <meta name="keywords" content="Huertas solares" />
        </Helmet>
        <div className="wrapper">
          <Row className="h-100 bgimage">
            <Col
              xs={12}
              sm={6}
              md={6}
              xl={6}
              className="d-none d-sm-block loginCol1 "
            >
              <p></p>
            </Col>
            <Col xs={12} sm={6} md={6} xl={6} className="loginCol2 ">
              <div className="d-flex  align-items-center flex-column justify-content-center h-100">
                <img draggable="false" className="" src={myImage} />
                <div className="bg-light p-4 rounded mt-5">
                  <form
                    onSubmit={logIn}
                    className="d-flex flex-column  align-items-center"
                  >
                    <label
                      style={{ width: "85%" }}
                      onChange={handleChangeForm}
                      className="mb-2 "
                    >
                      <p className="mb-1">Usuario:</p>
                      <input
                        name="username"
                        className="bg-light ml-2 w-100 p-2 rounded border border-secondary"
                        type="text"
                      ></input>
                    </label>
                    <label
                      style={{ width: "85%" }}
                      onChange={handleChangeForm}
                      className="mb-3"
                    >
                      <p className="mb-1">Contraseña:</p>
                      <div className="ml-2 w-100 p-2 rounded border border-secondary d-flex">
                        <input
                          className="bg-light w-100 border-0"
                          name="password"
                          type={`${mostrarPassword ? "text" : "password"}`}
                        ></input>
                        <span
                          onClick={handleChangeShowPassword}
                          className={`mdi pointer  ${
                            mostrarPassword
                              ? "mdi-eye-off-outline"
                              : "mdi-eye-outline"
                          }`}
                        ></span>
                      </div>
                    </label>

                    {errorMessage && (
                      <Alert color="danger mt-2 w-100 text-center">
                        {errorMessage}
                      </Alert>
                    )}
                    <div className="recaptcha">
                      {/* process.env.REACT_APP_RECAPTCHA_SITE_KEY */}
                      <ReCAPTCHA
                        ref={reCaptcha}
                        sitekey={process.env.REACT_APP_RECAPTCHA_SITEKEY}
                        onChange={onChangeReCaptcha}
                      ></ReCAPTCHA>
                    </div>
                    {captchaValido === false && (
                      <Alert className="mt-3" color="danger">
                        Por favor, completa el captcha
                      </Alert>
                    )}
                    {status === "checking" && (
                      <SpinnerAvantsolar></SpinnerAvantsolar>
                    )}
                    <button className="w-100 btn botonLogin rounded text-black">
                      Iniciar Sesión
                    </button>
                  </form>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </>
    );
  } else {
    return redirigirSegunUser(user);
  }
}

export default Login;
